import React, {useContext} from 'react';
import './Offers.less';
import {PseudoPagePopup} from "dialog-layout/pseudo-page-popup/PseudoPagePopup";
import {Card} from "elements/card/Card.tsx";
import {OfferList} from "compositions/offer-list/OfferList";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {EmptyPlaceholder} from "elements/empty-placeholder/EmptyPlaceholder";
import {CardStyles} from "../../elements/card/Card";

export const OFFERS_POPUP = 'OFFERS_POPUP';

export const Offers = ({offers, onOverlayClick}) => {
	const translations = useContext(TranslationsContext);

	return <PseudoPagePopup
		title={getSafeTranslation('OffersPopup.title', translations)}
		description={getSafeTranslation('OffersPopup.description', translations)}
		onBackClick={onOverlayClick}>
		<Card style={CardStyles.NESTED}>
			{
				offers.length > 0
					? (<OfferList
						offers={offers}
					/>)
					: <EmptyPlaceholder text={getSafeTranslation('OffersPopup.emptyPlaceholder', translations)}/>
			}

		</Card>
	</PseudoPagePopup>
}
